import KnowledgeBaseDashboardAppConfig from './knowledge_base/KnowledgeBaseDashboardAppConfig';
import UsageDashboardAppConfig from './home/HomeDashboardAppConfig';
import QueryDashboardAppConfig from './query/QueryDashboardAppConfig';
import OrganisationConfig from './organisation/OrganisationConfig';
import HistoryQueriesAppConfig from './historyQueries/HistoryQueriesAppConfig';
import ScrumboardConfig from './scrumboard/ScrumboardConfig';
import PlaygroundDashboardAppConfig from './playground/PlaygroundDashboardAppConfig';

const dashboardsConfigs = [
  UsageDashboardAppConfig,
  QueryDashboardAppConfig,
  KnowledgeBaseDashboardAppConfig,
  OrganisationConfig,
  HistoryQueriesAppConfig,
  ScrumboardConfig,
  PlaygroundDashboardAppConfig,
];

export default dashboardsConfigs;
